import { IMAGES } from "./site";

export const PRODUCTS = [
  {
    slug: "rubber-process-oil",
    code: "RPO",
    name: "Rubber Process Oil (RPO)",
    shortName: "Rubber Process Oil",
    tagline: "Aromatic rubber process oils designed to provide excellent processing, plasticizing and compounding performance across tyre and industrial rubber applications.",
    image: "https://images.unsplash.com/photo-1558617867-659c667b6809?w=1600&q=80&auto=format&fit=crop",
    description:
      "Rubber Process Oil (RPO) is a petroleum-based process oil used extensively in the rubber industry as a processing aid, plasticizer and extender. Our aromatic RPO range offers good compatibility with rubber compounds, effective plasticizing properties and consistent processing performance. Available in multiple viscosity grades, RPO can be selected according to compound formulation, processing requirements and end-use performance.",
    gradeGroups: [
      { label: "Viscosity grades", items: ["RPO 125", "RPO 135", "RPO 145", "RPO 155"] },
    ],
    gradeTable: {
      columns: ["Parameter", "RPO 125", "RPO 135", "RPO 145", "RPO 155"],
      rows: [
        ["Type", "Aromatic", "Aromatic", "Aromatic", "Aromatic"],
        ["Kinematic Viscosity @ 100°C", "20 – 30 cSt", "30 – 40 cSt", "40 – 50 cSt", "50 – 60 cSt"],
        ["Flash Point, Min.", "220°C", "230°C", "230°C", "230°C"],
        ["Pour Point, Typical", "+36°C", "+33°C", "+27°C", "+33°C"],
        ["Aniline Point, Max.", "45°C", "40°C", "35°C", "30°C"],
      ],
    },
    notesTitle: "Product characteristics",
    gradeNotes: [
      { grade: "Good Rubber Compatibility", note: "Aromatic composition provides compatibility with a broad range of rubber compounds." },
      { grade: "Effective Plasticizing", note: "Helps improve compound processing and facilitates mixing and manufacturing." },
      { grade: "Multiple Viscosity Grades", note: "Grades ranging from 20–30 cSt through 50–60 cSt at 100°C allow selection according to specific formulation and processing requirements." },
      { grade: "Industrial Versatility", note: "Suitable for tyre, automotive, footwear and general technical rubber applications." },
    ],
    specsNote:
      "Typical product specifications. Final contractual specifications and batch-specific results are confirmed against the applicable Certificate of Analysis (CoA).",
    specs: [],
    applications: ["Tyre manufacturing", "Automotive rubber components", "Conveyor belts", "Hoses & rubber pipes", "Footwear & rubber soles", "Industrial rubber products", "Rubber compounding", "Printing inks"],
    packaging:
      "Standard industrial packaging and bulk shipment configurations, subject to grade and origin. Availability, packaging options, quantities, CoA and delivery terms on request.",
  },
  {
    slug: "base-oils",
    code: "SN / BS",
    name: "Base Oils",
    shortName: "Base Oils",
    tagline: "Group I & II virgin base stocks — SN150, SN500, SN600 and BS150 bright stock.",
    image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1600&q=80&auto=format&fit=crop",
    description:
      "Terra Bloom supplies virgin Group I and Group II base oils sourced from tier-one refineries across the Middle East and Asia. Consistent viscosity index, low sulfur and excellent oxidation stability make our base stocks the preferred feed for lubricant blenders producing engine oils, hydraulic fluids, gear oils and industrial lubricants.",
    specs: [
      { param: "Grades Available", standard: "—", value: "SN150 / SN500 / SN600 / BS150" },
      { param: "Kinematic Viscosity @ 40°C", standard: "ASTM D445", value: "28 – 32 / 95 – 105 cSt" },
      { param: "Viscosity Index", standard: "ASTM D2270", value: "95 – 105" },
      { param: "Flash Point (COC)", standard: "ASTM D92", value: "≥ 220°C" },
      { param: "Pour Point", standard: "ASTM D97", value: "−6 to −12°C" },
      { param: "Sulfur Content", standard: "ASTM D4294", value: "≤ 0.8 wt%" },
    ],
    applications: ["Automotive engine oils", "Hydraulic fluids", "Gear & transmission oils", "Turbine & compressor oils", "Greases"],
    packaging: "Flexi-tanks, ISO tanks, 208L drums, bulk vessel",
  },
  {
    slug: "paraffin-wax-semi-refined",
    code: "PW",
    name: "Paraffin Wax",
    shortName: "Paraffin Wax",
    tagline: "High-quality semi-refined and fully refined paraffin wax for industrial, manufacturing and commercial applications.",
    image: "https://images.unsplash.com/photo-1603006905003-be475563bc59?w=1600&q=80&auto=format&fit=crop",
    description:
      "Paraffin wax is a refined petroleum-derived wax characterized by its crystalline structure, controlled melting range and consistent performance. It is solid and translucent at ambient temperature and becomes a clear liquid when melted. Produced through the controlled refining of slack wax, paraffin wax is available in different oil-content grades to meet varying industrial requirements. Key characteristics include controlled melting properties, low oil content, good stability and reliable processing performance.",
    gradeGroups: [
      { label: "Oil content grades", items: ["Max 2% oil", "3 – 5% oil", "5 – 8% oil"] },
    ],
    gradeTable: {
      columns: ["Parameter", "Test Method", "2% Grade", "3–5% Grade", "5–8% Grade"],
      rows: [
        ["Oil Content", "ASTM D721", "Max. 2 wt%", "3 – 5 wt%", "5 – 8 wt%"],
        ["Congealing Point", "ASTM D938", "59 – 65°C", "60 – 65°C", "45 – 75°C"],
        ["Colour @ 70°C", "ASTM D1500", "Max. 2", "Max. 2", "Max. 2"],
        ["Flash Point", "ASTM D92", "Min. 230°C", "Min. 230°C", "Min. 230°C"],
      ],
    },
    notesTitle: "Product characteristics",
    gradeNotes: [
      { grade: "Controlled Oil Content", note: "Multiple grades available to suit different processing and end-use requirements." },
      { grade: "Consistent Melting Performance", note: "Controlled congealing characteristics suitable for a broad range of industrial applications." },
      { grade: "Good Processing Characteristics", note: "Designed for reliable melting, blending, coating and manufacturing processes." },
      { grade: "Versatile Industrial Use", note: "Suitable for applications across candles, packaging, rubber, coatings and other industrial sectors." },
    ],
    specsNote:
      "Values shown represent typical product specifications. Final contractual specifications and batch-specific results are confirmed against the applicable Certificate of Analysis (CoA).",
    specs: [],
    applications: ["Candle manufacturing", "Packaging & coatings", "Rubber & tyre industry", "Polishes & surface treatments", "Matches & firelighters", "Industrial processing"],
    packaging:
      "Typically 25–30 kg cartons containing approx. 5–6 kg slabs. Alternative packing configurations by grade and origin. Availability, packing, quantities, CoA and delivery terms on request.",
  },
  {
    slug: "lubricants-engine-oil",
    code: "LUBE",
    name: "Lubricants (Engine Oil / Motor Oil)",
    shortName: "Lubricants & Engine Oils",
    tagline: "Finished engine oils and industrial lubricants blended to API SN/CF performance levels.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1600&q=80&auto=format&fit=crop",
    description:
      "From our blending partners we offer a finished lubricants range covering passenger car motor oils (SAE 5W-30, 10W-40, 20W-50), heavy-duty diesel engine oils (15W-40, 20W-50 CI-4), hydraulic oils (HLP 32/46/68) and transmission fluids. Every batch is blended from virgin base stocks with branded additive packages and shipped with a certificate of analysis.",
    specs: [
      { param: "Viscosity Grades", standard: "SAE J300", value: "5W-30 to 20W-50" },
      { param: "Performance Level", standard: "API", value: "SN / SN PLUS / CI-4" },
      { param: "Kinematic Viscosity @ 100°C", standard: "ASTM D445", value: "9.3 – 21.9 cSt (by grade)" },
      { param: "Viscosity Index", standard: "ASTM D2270", value: "≥ 120 (multigrade)" },
      { param: "Pour Point", standard: "ASTM D97", value: "≤ −24°C (multigrade)" },
      { param: "TBN", standard: "ASTM D2896", value: "7 – 10 mg KOH/g" },
    ],
    applications: ["Passenger vehicles", "Heavy-duty diesel fleets", "Marine auxiliaries", "Construction equipment", "Power generation"],
    packaging: "1L / 4L / 5L retail packs, 208L drums, IBC, flexi-tanks",
  },
  {
    slug: "slack-wax",
    code: "SW",
    name: "Slack Wax",
    shortName: "Slack Wax",
    tagline: "Crude wax fractions with 5–30% oil content for wax refining, matches and particle board.",
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=1600&q=80&auto=format&fit=crop",
    description:
      "Slack wax is the raw feedstock of the wax industry — a crude paraffin fraction recovered during lube oil dewaxing. We trade light and heavy slack wax grades with oil contents from 5% to 30%, shipped in bulk, drums or slabs. Primary uses include paraffin wax refining, match manufacturing, particle board moisture-proofing, candles and rust-protective compounds.",
    specs: [
      { param: "Oil Content", standard: "ASTM D721", value: "5 – 30 wt% (by grade)" },
      { param: "Melting Point", standard: "ASTM D87", value: "48 – 60°C" },
      { param: "Color", standard: "Visual", value: "Light yellow to brown" },
      { param: "Flash Point (COC)", standard: "ASTM D92", value: "≥ 190°C" },
      { param: "Specific Gravity @ 15°C", standard: "ASTM D1298", value: "0.90 – 0.94" },
      { param: "Kinematic Viscosity @ 100°C", standard: "ASTM D445", value: "4 – 8 cSt" },
    ],
    applications: ["Paraffin wax refining", "Match industry", "Particle board & MDF", "Candle blending", "Rust protective coatings"],
    packaging: "Bulk liquid (heated), 180 kg drums, slabs in bags",
  },
  {
    slug: "residue-wax",
    code: "RW",
    name: "Residue Wax",
    shortName: "Residue Wax",
    tagline: "High oil-content residue wax for match, board sizing and emulsion applications.",
    image: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1600&q=80&auto=format&fit=crop",
    description:
      "Residue wax is the high oil-content fraction sweated from slack wax during paraffin refining. With oil content typically between 30% and 40%, it is a cost-effective raw material for match splints, particle board sizing, wax emulsions, candle economy blends and as a feedstock for further deoiling.",
    specs: [
      { param: "Oil Content", standard: "ASTM D721", value: "30 – 40 wt%" },
      { param: "Drop Melting Point", standard: "ASTM D127", value: "45 – 55°C" },
      { param: "Color", standard: "Visual", value: "Brown" },
      { param: "Flash Point (COC)", standard: "ASTM D92", value: "≥ 180°C" },
      { param: "Kinematic Viscosity @ 100°C", standard: "ASTM D445", value: "3.5 – 6 cSt" },
      { param: "Specific Gravity @ 15°C", standard: "ASTM D1298", value: "0.88 – 0.92" },
    ],
    applications: ["Match splint impregnation", "Board sizing & water-proofing", "Wax emulsions", "Economy candle blends", "Further wax deoiling"],
    packaging: "Bulk liquid (heated), 180 kg drums",
  },
  {
    slug: "polybutadiene-rubber-pbr",
    code: "PBR 1220",
    name: "Polybutadiene Rubber (PBR 1220)",
    shortName: "Polybutadiene (PBR 1220)",
    tagline: "High-cis polybutadiene rubber engineered for excellent abrasion resistance, resilience and dynamic performance in tyre and industrial rubber applications.",
    image: "https://images.unsplash.com/photo-1606053929013-311c13f97b5f?w=1600&q=80&auto=format&fit=crop",
    description:
      "PBR 1220 is a high-cis polybutadiene rubber offering excellent elasticity, abrasion resistance, low heat build-up and resistance to dynamic stress. Its high cis content and mechanical properties make it particularly suitable for tyres and technical rubber products. PBR 1220 can also be blended with natural rubber (NR) and styrene-butadiene rubber (SBR) to achieve the required balance of durability, resilience and processing performance.",
    specs: [
      { param: "Raw Mooney Viscosity", standard: "ASTM D1646", value: "41 – 49 MU" },
      { param: "Cis Content", standard: "Internal Method", value: "≥ 96 wt%" },
      { param: "Volatile Matter Content", standard: "ASTM D5668", value: "≤ 0.75 wt%" },
      { param: "Ash Content", standard: "ASTM D1416", value: "≤ 0.30 wt%" },
      { param: "Compound Mooney Viscosity", standard: "ASTM D1646", value: "≤ 77 MU" },
      { param: "Tensile Strength (35 min)", standard: "ASTM D412", value: "≥ 150 kgf/cm²" },
      { param: "Elongation at Break (35 min)", standard: "ASTM D412", value: "≥ 440%" },
      { param: "300% Modulus @ 145°C — 25 min cure", standard: "ASTM D412", value: "68 – 108 kg/cm²" },
      { param: "300% Modulus @ 145°C — 35 min cure", standard: "ASTM D412", value: "74 – 114 kg/cm²" },
      { param: "300% Modulus @ 145°C — 50 min cure", standard: "ASTM D412", value: "74 – 114 kg/cm²" },
    ],
    applications: ["Tyre treads & sidewalls", "Conveyor belts", "Shoe soles & heels", "Hoses & hosepipes", "Cables", "Technical rubber goods"],
    packaging: "Standard manufacturer packaging suitable for international shipment. Configuration, quantities and delivery terms on request.",
  },
  {
    slug: "styrene-butadiene-rubber-sbr",
    code: "SBR",
    name: "Styrene Butadiene Rubber (SBR)",
    shortName: "Styrene Butadiene Rubber (SBR)",
    tagline: "Versatile synthetic rubber offering excellent abrasion resistance, processability and durability for tyre and industrial rubber applications.",
    image: "https://images.unsplash.com/photo-1710141530542-f792450e736e?w=1600&q=80&auto=format&fit=crop",
    description:
      "Styrene Butadiene Rubber (SBR) is a widely used synthetic rubber produced by cold-emulsion copolymerization of styrene and butadiene. SBR combines good abrasion resistance, processability and consistent performance, making it particularly suitable for tyre manufacturing and a broad range of industrial rubber products. Available in both non-oil-extended and oil-extended grades, allowing customers to select the appropriate grade according to processing requirements and end-use application.",
    gradeGroups: [
      { label: "Non-oil-extended", items: ["SBR 1500", "SBR 1502", "SBR 1507"] },
      { label: "Oil-extended", items: ["SBR 1705", "SBR 1712", "SBR 1721", "SBR 1723"] },
    ],
    gradeTable: {
      columns: ["Grade", "Type", "Bound Styrene", "Oil Content", "Mooney ML 1+4 @ 100°C"],
      rows: [
        ["SBR 1500", "Non-oil extended", "23.5%", "—", "46 – 58"],
        ["SBR 1502", "Non-oil extended", "23.5%", "—", "46 – 58"],
        ["SBR 1507", "Non-oil extended", "23.5%", "—", "30 – 40"],
        ["SBR 1705", "Oil extended", "23.5%", "37.5 phr", "46 – 56"],
        ["SBR 1712", "Oil extended", "23.5%", "37.5 phr", "42 – 52"],
        ["SBR 1721", "Oil extended", "40%", "37.5 phr", "50 – 60"],
        ["SBR 1723", "Oil extended", "23.5%", "37.5 phr", "42 – 52"],
      ],
    },
    gradeNotes: [
      { grade: "SBR 1500", note: "General-purpose non-oil-extended grade suitable for automobile tyres, conveyor belts, footwear, cables, hoses and technical rubber goods." },
      { grade: "SBR 1502", note: "Non-oil-extended grade particularly suited to light-coloured rubber products, including tyres, floor coverings, bicycle tyres, footwear, toys, cables and rubber pipes." },
      { grade: "SBR 1507", note: "Lower-Mooney grade offering good processability for sponge products, industrial rubber goods, rubberized fabrics, toys and black rubber products." },
      { grade: "SBR 1705 / 1712 / 1723", note: "Oil-extended grades designed primarily for tyres and general industrial rubber applications where processing characteristics and compound economics are important." },
      { grade: "SBR 1721", note: "Oil-extended, higher-styrene grade containing approximately 40% bound styrene, suitable where higher styrene content is required in the compound formulation." },
    ],
    specsNote:
      "All listed grades use non-staining (NS) antioxidant systems. Values shown are typical grade specifications — final contractual specifications and batch-specific results are confirmed against the applicable Certificate of Analysis (CoA).",
    specs: [],
    applications: ["Automobile tyres", "Conveyor belts", "Footwear", "Cables", "Hoses & rubber pipes", "Technical rubber goods"],
    applicationsExtra:
      "Additional grade-specific applications include floor coverings, bicycle tyres, rubberized fabrics, sponge products and other molded or extruded rubber goods.",
    packaging:
      "Standard manufacturer packaging suitable for international shipment. Grade availability, packaging configuration, shipment quantities, CoA and delivery terms on request.",
  },
  {
    slug: "styrenated-phenol-sph",
    code: "SPH",
    name: "Styrenated Phenol (SPH)",
    shortName: "Styrenated Phenol (SPH)",
    tagline: "Non-staining liquid antioxidant and stabilizer for synthetic rubber and latex.",
    image: "https://images.pexels.com/photos/12845179/pexels-photo-12845179.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
    description:
      "Styrenated phenol is a clear, pale-yellow liquid antioxidant produced by alkylation of phenol with styrene. It is the standard non-staining stabilizer for emulsion SBR, NBR, BR and natural/synthetic latex — protecting polymers against heat, oxygen and flex-cracking degradation during processing, storage and service. Also used as an antioxidant in adhesives and sealant systems.",
    specs: [
      { param: "Appearance", standard: "Visual", value: "Clear pale-yellow viscous liquid" },
      { param: "Purity (GC)", standard: "GC", value: "≥ 98%" },
      { param: "Density @ 25°C", standard: "ASTM D4052", value: "1.03 – 1.09 g/cm³" },
      { param: "Viscosity @ 25°C", standard: "ASTM D445", value: "3,000 – 7,000 cP" },
      { param: "Refractive Index @ 25°C", standard: "ASTM D1218", value: "1.59 – 1.61" },
      { param: "Flash Point (COC)", standard: "ASTM D92", value: "≥ 180°C" },
    ],
    applications: ["SBR / NBR / BR stabilization", "Natural & synthetic latex", "Adhesives & sealants", "Rubber goods antioxidant", "Polymer processing aid"],
    packaging: "200 kg steel drums, 1,000 kg IBC",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

const RUBBER_SLUGS = ["polybutadiene-rubber-pbr", "styrene-butadiene-rubber-sbr", "styrenated-phenol-sph"];
PRODUCTS.forEach((p) => {
  p.category = RUBBER_SLUGS.includes(p.slug) ? "rubber" : "petroleum";
});

export const CATEGORIES = [
  { id: "petroleum", label: "Petroleum Products", blurb: "Oils, waxes and lubricants refined and blended to spec." },
  { id: "rubber", label: "Rubber & Chemicals", blurb: "Synthetic rubber polymers and antioxidants for tyre and polymer plants." },
];
